import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/bipolar-disorder-springs-fl")({
  beforeLoad: () => {
    throw redirect({ to: "/bipolar-disorder-coral-springs-fl" });
  },
});
